import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { OperationUser } from "./OperationUserData";

// Backed by SalesProject.API.Controllers/API/Operation/UsersController.cs (GET api/Operation/Users),
// which proxies IAccountsAppUserService.GetUsersForOperationAsync - the identity server is not
// called directly from here.
export const OperationDataGetUsersQuery: AgTechQuery<any, AgTechIndex<OperationUser>> = {
    queryKey: () => ['OperationUsers'],
    query: (props) => {
        return props.http.getEntity<OperationUser[], AgTechIndex<OperationUser>>({
            request: 'Operation/Users',
            convert: users => Index(users, user => user.id)
        });
    },
    content: {
        loadingText: 'Loading users...',
        failureText: 'Failed to load users.'
    }
}
